export const headerData = {
  title: 'Experience & Projects',
  description:
    'My experience in software development, technical support, customer success, marketing and community projects',
};

const timelineItems = [
  {
    time: 'June 2025 to Present',
    title: 'Web Software Engineer & Support Engineer',
    description:
      'Working on web applications, technical support and software troubleshooting:',
    company: {
      name: 'Sensory Minds',
      link: 'https://www.sensory-minds.com/',
    },
    location: 'Germany, Remote',
    workList: [
      'Investigate web application issues, reproduce bugs and collaborate with developers to identify root causes and support reliable fixes',
      'Support QA validation, technical documentation and workflow improvements across web projects',
    ],
    references: false,
    jobDescription: 'See Sensory Minds website:',
  },
  {
    time: 'January 2022 to January 2024',
    title: 'Software Developer',
    description:
      'Developing web applications within an Agile engineering team:',
    company: {
      name: 'AUTO1 Group',
      link: 'https://www.auto1.com/de/home',
    },
    location: 'Berlin, Germany',
    workList: [
      'Developed and maintained web applications with React, TypeScript and JavaScript, including responsive interfaces and reusable components',
      'Worked with REST APIs, resolved frontend bugs and collaborated on features, releases and sprint planning using Git and Jira',
    ],
    references: false,
    jobDescription: 'See AUTO1 website:',
  },
  {
    time: 'June 2018 to December 2020',
    title: 'Customer Success Manager',
    description:
      'Supporting customers and improving customer experience:',
    company: {
      name: 'PayPal',
      link: 'https://www.paypal.com/',
    },
    location: 'Berlin, Germany',
    workList: [
      'Resolved complex customer issues and improved customer experience in an international environment',
      'Analyzed customer behavior to support business decisions',
    ],
    references: false,
    jobDescription: 'See PayPal website:',
  },
  {
    time: 'February 2016 to January 2018',
    title: 'Growth Marketing & Campaign Manager',
    description:
      'Managing digital marketing campaigns and customer acquisition:',
    company: {
      name: 'Mona Tours',
      link: '',
    },
    location: '',
    workList: [
      'Planned and optimized digital campaigns, analyzed performance and supported customer acquisition',
    ],
    references: false,
    jobDescription: '',
  },
  {
    time: 'January 2014 to January 2016',
    title: 'Marketing & Sales Specialist',
    description:
      'Supporting marketing, customer engagement and sales:',
    company: {
      name: 'Daka 90',
      link: '',
    },
    location: '',
    workList: [
      'Supported marketing campaigns, customer engagement and sales initiatives',
    ],
    references: false,
    jobDescription: '',
  },
  {
    time: 'Community leadership for 2.5 years, ongoing',
    title: 'Founder, Developer & Community Manager',
    description:
      'Volunteer community leadership and website development:',
    company: {
      name: 'Berlinim',
      link: 'https://berlinim.com/',
    },
    location: '',
    workList: [
      'Manage a growing community of approximately 1,800 members across Facebook and WhatsApp',
      'Built and launched a Next.js website for community events, with plans to expand into additional community topics and resources',
    ],
    references: false,
    jobDescription: 'See Berlinim website:',
  },
  {
    time: 'December 2023 to February 2024',
    title: 'WordPress Website Improvement & Training',
    description:
      'Temporary project focused on website improvements and user training:',
    company: {
      name: 'Inter G',
      link: '',
    },
    location: '',
    workList: [
      'Improved the company website, working directly with the CEO and management',
      'Guided them on website updates and trained them to use WordPress independently',
    ],
    references: false,
    jobDescription: '',
  },
  {
    time: 'January 2024 to May 2025',
    title: 'Browser Game Development',
    description: 'Volunteer software development project:',
    company: {
      name: 'Web Gaming Platform',
      link: '',
    },
    location: '',
    workList: [
      'Developed browser games for a web gaming platform, including interfaces, game logic, interactions and animations',
    ],
    references: false,
    jobDescription: '',
  },
  {
    time: '2025',
    title: 'Growth Marketing Certificate',
    description: 'Education:',
    company: {
      name: 'Le Wagon',
      link: 'https://www.lewagon.com/',
    },
    location: '',
    workList: ['Completed a Growth Marketing certificate'],
    references: false,
    jobDescription: 'See Le Wagon website:',
  },
  {
    time: '2020 to 2021',
    title: 'Full Stack Web Development Diploma',
    description: 'Education:',
    company: {
      name: 'DCI',
      link: 'https://digitalcareerinstitute.org/',
    },
    location: '',
    workList: ['Completed a Full Stack Web Development diploma'],
    references: false,
    jobDescription: 'See DCI website:',
  },
  {
    time: '2016 to 2018',
    title: 'B.A. in Digital Marketing',
    description: 'Education:',
    company: {
      name: 'Sapir College',
      link: '',
    },
    location: '',
    workList: ['Completed a B.A. in Digital Marketing'],
    references: false,
    jobDescription: '',
  },
];

export default timelineItems;